module.exports = __webpack_public_path__ + "img/spotify (1).457956a1.svg";